import SofiaProLight from 'assets/fonts/SofiaProLight.woff2';
import SofiaProRegular from 'assets/fonts/SofiaProRegular.woff2';
import SofiaProSemiBold from 'assets/fonts/SofiaProSemiBold.woff2';

/* Font Faces
 * Style Linking: https://www.fontspring.com/support/style-linking */

export const headStyles = `
  html, body {
    font-size: 14px;
  }
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProLight}) format('woff2');
    font-weight: 300; /* light */
  }
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProRegular}) format('woff2');
    font-weight: 400; /* normal */
  }
  @font-face {
    font-family: 'Sofia Pro';
    src: url(${SofiaProSemiBold}) format('woff2');
    font-weight: 600; /* "semi-bold" */
  }
`;

export const HeadStyle = () => {
  return <style>{headStyles}</style>;
};

export default HeadStyle;
